module.exports = __webpack_public_path__ + "static/media/step3.91f123cb.jpg";